import { getAuthAxiosBackend } from "../helpers/axios"

class SocialMediaServices{

    constructor(){
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('social_media', {params: data})
    }

    edit(id, social){
        return getAuthAxiosBackend().put('social_media' + '/' + id, social)
    }
}

export default new SocialMediaServices()